import { Component, Input, TemplateRef } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Servico } from 'src/app/models/Servico.model';

@Component({
  selector: 'app-base-servico',
  template: `
    <div *ngIf="!servico">
      <p-progressSpinner></p-progressSpinner>
    </div>
    <div *ngIf="servico">
      <app-titulo [texto]="servico.nome"></app-titulo>
      <p
        class="text-md font-opensans mb-3 text-justify text-700"
        [innerHTML]="servico.descricao"
      ></p>
      <div
        *ngIf="servico.mensagemMatricula"
        class="text-md font-opensans mb-3 text-justify text-700"
        [innerHTML]="servico.mensagemMatricula"
      ></div>
      <p class="text-md font-opensans mb-3 text-justify text-700" *ngIf="mostrarTermoAceite && servico.linkDeclaracoes">
        <a [href]="servico.linkDeclaracoes" target="_blank" class="font-bold"> CLIQUE AQUI</a> para baixar a Declaração de Veracidade/Declaração de Aceite
      </p>
      <p-card>
        <div class="conteudo">
          <p-steps
            [model]="STEPS_ITEMS"
            [readonly]="true"
            [activeIndex]="activeIndex"
            class="steps"
          ></p-steps>

          <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>

          <ng-container *ngIf="activeIndex == 0">
            <ng-container
              *ngTemplateOutlet="solicitanteTemplate"
            ></ng-container>
          </ng-container>

          <ng-container *ngIf="activeIndex == 1">
            <ng-container *ngTemplateOutlet="servicoTemplate"></ng-container>
          </ng-container>

          <ng-container *ngIf="activeIndex == 2">
            <ng-container
              *ngTemplateOutlet="confirmacaoTemplate"
            ></ng-container>
          </ng-container>
        </div>
      </p-card>
      <p-dialog
        [closable]="false"
        [modal]="true"
        [visible]="!understand && servico != null"
        styleClass="w-full m-2 max-h-screen md:w-5"
        header="Informações do serviço"
      >
        <pre
          [innerHTML]="servico.explicativo"
          style="font-family: 'Open Sans', sans-serif; white-space: pre-wrap"
        ></pre>
        <ng-template pTemplate="footer">
          <div class="w-full text-left">
            <p-checkbox
              [(ngModel)]="understand"
              [binary]="true"
              inputId="understand"
            ></p-checkbox>
            <label for="understand" class="text-sm">
              Estou ciente da documentação necessária, e que caso a documentação
              apresentada não esteja de acordo com a exigida a solicitação será
              rejeitada.
            </label>
          </div>
        </ng-template>
      </p-dialog>
    </div>
  `,
  styleUrls: ['base-servico.component.css'],
})
export class BaseServicoComponent {
  @Input({ required: true }) servico?: Servico;
  @Input({ required: true }) activeIndex: number = 0;

  @Input() headerTemplate: TemplateRef<any> | null = null;
  @Input({ required: true }) solicitanteTemplate: TemplateRef<any> | null =
    null;
  @Input({ required: true }) servicoTemplate: TemplateRef<any> | null = null;
  @Input({ required: true }) confirmacaoTemplate: TemplateRef<any> | null =
    null;
  @Input() understand: boolean = false;

  @Input() mostrarTermoAceite: boolean = false;

  STEPS_ITEMS: MenuItem[] = [
    { label: 'Solicitante' },
    { label: 'Serviço' },
    { label: 'Confirmação' },
  ];

}
